var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.96088 15.6384L0.350548 8.84606C0.233699 8.74275 0.146062 8.61792 0.087637 8.47157C0.0292124 8.32522 0 8.16596 0 7.99378C0 7.83882 0.0292124 7.69247 0.087637 7.55473C0.146062 7.41699 0.233699 7.29647 0.350548 7.19316L6.98592 0.32331C7.20292 0.0994799 7.47001 -0.00813057 7.78717 0.000478269C8.10433 0.00908711 8.37141 0.133915 8.58842 0.374962C8.78873 0.598792 8.89306 0.874275 8.90141 1.20141C8.90975 1.52855 8.80543 1.80403 8.58842 2.02786L3.93114 6.83159H14.8732C15.1904 6.83159 15.4575 6.9435 15.6745 7.16733C15.8915 7.39116 16 7.66665 16 7.99378C16 8.35535 15.8915 8.64375 15.6745 8.85897C15.4575 9.07419 15.1904 9.1818 14.8732 9.1818H3.93114L8.61346 14.0114C8.83046 14.2524 8.93479 14.5322 8.92645 14.8507C8.9181 15.1692 8.80543 15.4318 8.58842 15.6384C8.35472 15.8795 8.07929 16 7.76213 16C7.44497 16 7.17788 15.8795 6.96088 15.6384Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.59570bfc1dd8bde5b941d66651d62091.svg";
export { ForwardRef as ReactComponent };